import React from 'react'
import { Icon, Message } from 'semantic-ui-react'
import { Trans } from 'react-i18next'

// CODE_COMMENTS_271
export default function DifferenceBetweenZeroAndBlankKegQtyFieldMessage({ arbitraryContent }) {
  const message = arbitraryContent || <Trans i18nKey="noKegsOfSpecificType" ns="common" />
  return (
    <Message
      info
      compact
      style={{
        margin: 0,
        padding: '0.5em 1em',
      }}
    >
      <Icon name="info" />
      {message}
    </Message>
  )
}
